<template>
  <el-card class="box-card main-card" style="position: relative">
    <el-form class="search-form" ref="form" :model="searchForm" style="display: inline-block">
      <el-form-item label="支付方式：" label-width="90px">
        <!-- <el-select v-model="searchForm.status"
                   @change="getUacCertification"
                   placeholder="请选择状态" style="width:120px"> -->
        <el-select
          v-model="searchForm.type"
          @change="searchFn"
          placeholder="请选择支付方式"
          style="width: 150px"
          clearable
        >
          <el-option
            v-for="item in typeList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="支付状态：" label-width="90px">
        <el-select
          v-model="searchForm.status"
          @change="searchFn"
          placeholder="支付状态"
          style="width: 150px"
          clearable
        >
          <el-option
            v-for="item in statusList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="支付时间：" label-width="90px">
        <DatePicker v-model="dateValue"   @changeDatePicker="getData" />
      </el-form-item>
    </el-form>
    <!-- <FilenameOption v-model="filename" />-->
    <!--    <AutoWidthOption v-model="autoWidth" />-->
    <div style="display: inline-block;float: right">
      <BookTypeOption v-model="bookType" />
      <PageSizeOption v-model="pageSize"  @changePageSize="changePageSize"/>
      <el-button :loading="downloadLoading" style="margin:0 0 15px 15px;" type="primary" size="small" icon="el-icon-document" @click="handleDownload">
        导出
      </el-button>
    </div>
    <template>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="userLoginId" label="loginId">
        </el-table-column>
        <el-table-column prop="userCompany" label="公司">
        </el-table-column>
        <el-table-column prop="userMobile" label="手机号">
        </el-table-column>

        <el-table-column prop="name" label="支付方式">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 11">微信</span>
            <span v-if="scope.row.type == 21">支付宝扫码</span>
            <span v-if="scope.row.type == 31">后台管理员充值--赠送金额</span>
            <span v-if="scope.row.type == 41">后台管理员充值--用户储值金额</span>
            <span v-if="scope.row.type == 91">到期扣费--用户扣减</span>
          </template>
        </el-table-column>
        <el-table-column label="金额" prop="amount">
          <template slot-scope="scope">
            <span>￥{{ scope.row.amount/100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付账号" prop="tradeNo">

        </el-table-column>
        <el-table-column prop="amount" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" style="color:#E6A23C;">未完成支付</span>
            <span v-if="scope.row.status == 1" style="color:#67C23A;">支付成功</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createDate | formatDate }}
          </template>
        </el-table-column>

      </el-table>
    </template>
    <PageComponent ref="pageInfo"></PageComponent>
  </el-card>
</template>

<script>
  import PageComponent from "@/components/pageInfo/PageComponent";
  import {formatDateTime} from "@/utils/util.js"
  import {Message} from "element-ui";
  import FilenameOption from "@/components/System/export/FilenameOption"
  import AutoWidthOption from "@/components/System/export/AutoWidthOption"
  import BookTypeOption from "@/components/System/export/BookTypeOption"
  import PageSizeOption from "@/components/pageInfo/PageSizeOption"
  import DatePicker from "@/components/datePicker/index"
  export default {
    components: {PageComponent,FilenameOption,AutoWidthOption,BookTypeOption,DatePicker,PageSizeOption},
    data() {
      return {
        searchForm: {
          type: 11,
          status: 1,
        },
        typeList: [
          {
            key: 11,
            value: "微信",
          },
          {
            key: 31,
            value: "后台管理员（赠送金额）",
          },
          {
            key: 41,
            value: "后台管理员（用户储值金额）",
          },
        ],
        statusList: [
          {
            key: 1,
            value: "支付成功",
          },
          {
            key: 0,
            value: "未支付",
          },
        ],
        tableData: [],
        pageSize: 10,
        downloadLoading: false,
        filename :'支付记录',
        autoWidth:true,
        bookType: "xlsx",
        dateValue:[]
      };
    },
    beforeCreate() {
    },
    created() {
    },
    methods: {
      getData: function () {
        var params = {};
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = this.pageSize;
        if (this.searchForm.type !== "") {
          params.type = this.searchForm.type;
        }
        if (this.searchForm.status !== "") {
          params.status = this.searchForm.status;
        }
        if(this.dateValue.length > 0){
          params.startTime = new Date(this.dateValue[0]).getTime() ;
          params.endTime = new Date(this.dateValue[1]).getTime() ;
        }

        this.getRequest("/ofcRechargeLog/list", params).then((resp) => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.tableData = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(
                resp.data.result.total,this.pageSize
              );
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error");
          }
        });
      },
      //切换状态搜索
      searchFn() {
        this.$router.push({query: {page: 1}});
        this.getData()
      },
      //页码变化
      changePageSize(curPageSize){
        this.pageSize = curPageSize;
        this.getData();
      },
      handleDownload() {
        this.downloadLoading = true
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = ['用户登录Id','所属公司', '用户电话号', '支付方式', '支付金额','支付状态', '支付账号', '支付时间']
          const filterVal = ['userLoginId','userCompany', 'userMobile', 'type','amount', 'status', 'tradeNo', 'createDate']
          const list = this.tableData
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          })
          this.downloadLoading = false
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          if (j === 'createDate') {
            return formatDateTime(v[j])
          } else if (j == 'type') {
            let type = "微信";
            if (v[j] == 31) {
              type = "管理员支付"
            } else if(v[j] == 11){
              type = "微信"
            }else {
              type = "其他"
            }
            return type
          } else if (j == 'status') {
            let type = "已支付";
            if (v[j] != 1) {
              type = "未支付"
            }
            return type
          }else if (j == 'amount') {
            return v[j]/100
          } else {
            return v[j]
          }
        }))
      },
    },
    mounted: function () {
      this.getData();
      this.$refs.pageInfo.initPagenator(this.getData, this.pageSize);
    },
    beforeDestroy() {
    },
  };
</script>

